import React from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';

import { downloadURL, getFilenameAndExtension } from 'utils/downloadUtils';

import Icon from './Icon';
import type { AbstractMedia } from '../../types/AbstractMedia';

const DocumentLine: React.FC<{
  document: AbstractMedia;
  hideDownload?: boolean;
  onPreview?: () => void;
  small?: boolean;
}> = ({ document, hideDownload, onPreview, small }) => {
  const intl = useIntl();
  const { name, extension } = getFilenameAndExtension(document.filename);

  const handleDownload = React.useCallback(() => {
    downloadURL(document.path, document.filename);
  }, [document]);

  const displayDownloadBtn = !hideDownload;
  const displayPreviewBtn = typeof onPreview === 'function';

  return (
    <div
      key={document.id}
      className="border-t-2 border-border-low first:border-0 first:pt-0"
    >
      <div className="flex justify-between items-center w-full">
        <span className="flex overflow-hidden font-medium text-base text-low max-w-min">
          <span className={classNames('overflow-hidden text-ellipsis whitespace-nowrap', small && 'text-xs')}>{name}</span>
          <span className={classNames('whitespace-nowrap shrink-0', small && 'text-xs')}>{extension}</span>
        </span>
        {displayDownloadBtn && (
          <div
            onClick={handleDownload}
            data-testid="download-document"
            className="cursor-pointer pl-2 flex items-center justify-center"
          >
            <Icon className="fb-icon--download text-2xl kiosk:text-4xl text-default"/>
          </div>
        )}
        {displayPreviewBtn && (
          <div
            className="cursor-pointer pl-2 flex items-center justify-center"
            data-testid="preview-document"
            onClick={onPreview}
            aria-label={intl.formatMessage({ id: 'accessibility.button.viewMedia', defaultMessage: 'View the media' })}
          >
            <Icon className="fb-icon--eye text-2xl kiosk:text-4xl text-default" />
          </div>
        )}
      </div>
    </div>
  );
};

export default DocumentLine;
